/*
 *  *
 *  *  * Copyright (c) 2023 Hg Digital, Setera
 *  *  *************************************************************
 *  *  *Projeto  : setera-web
 *  *  *Autor    : diegobrock
 *  *  *Data     : 04/07/2023 17:00
 *  *  *Empresa  : HG Digital/Setera
 *  *  *************************************************************
 *  *
 */

export enum HttpMethod {
    GET, POST, DELETE, PUT, PATCH
}
